/**
 * Slider de l'offre (#offre) : défilement horizontal automatique toutes les 3s,
 * sans flèches ni points. Boucle fluide grâce à un clone de la première slide.
 */
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.offre__slider');
  if (!slider) return;

  const track = slider.querySelector('.offre__track');
  if (!track) return;

  const slides = Array.from(track.children);
  if (slides.length < 2) return;

  const SLIDE_DURATION = 600; // doit correspondre à la transition CSS
  const INTERVAL = 5000;

  // Clone de la 1ère slide ajouté à la fin pour boucler sans à-coup
  const clone = slides[0].cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  track.appendChild(clone);

  const originalCount = slides.length;
  let index = 0;

  // Espace entre slides (lu depuis le CSS) pris en compte dans le décalage
  const getGap = () => parseFloat(getComputedStyle(track).columnGap) || 0;

  setInterval(() => {
    index++;
    track.style.transition = `transform ${SLIDE_DURATION}ms ease`;
    track.style.transform = `translateX(calc(-${index} * (100% + ${getGap()}px)))`;

    // Arrivé sur le clone (= 1ère slide), on revient au début sans transition
    if (index === originalCount) {
      setTimeout(() => {
        track.style.transition = 'none';
        index = 0;
        track.style.transform = 'translateX(0)';
      }, SLIDE_DURATION);
    }
  }, INTERVAL);
});
